import React from 'react';

import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { messages } from './messages';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import style from './additional-items-banner.module.less';

export const AdditionalItemsBanner = ({ onDismiss }) => {
  return (
    <BannerMessageV2
      buttons={
        <Button onClick={onDismiss} theme='link'>
          <FormattedMessage {...messages.dontShowThisAgain} />
        </Button>
      }
      className={style['additional-items-banner']}
      content={<Text textType={TextType.Paragraph} value={messages.additionalItemsBannerContent} />}
      header={<Text textType={TextType.Label} value={messages.additionalItemsBannerHeader} />}
      layout={BannerLayout.Full}
      status={BannerStatus.Info}
    />
  );
};

AdditionalItemsBanner.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};
